import { Dialog, Stack, Text, Box, Button } from "@origin-digital/ods-core";
import React from "react";

interface IDeleteDraftModal {
  open: boolean;
  setOpen: (open: boolean) => void;
  onConfirmCreatePremise: () => void;
}

const ConfirmCreateDuplicatePremiseModal = ({
  open,
  setOpen,
  onConfirmCreatePremise,
}: IDeleteDraftModal) => {
  const onCreate = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onConfirmCreatePremise();
  };

  return (
    <Dialog
      id="dialog"
      open={open}
      title="Are you sure?"
      hideClose={false}
      onClose={() => setOpen(false)}
    >
      <Stack space="small">
        {/* Content */}
        <Stack space="medium">
          <Text>
            You’re about to create a premise with the same address as the
            request you’re duplicating. Once the request is created, you won’t
            be able to change the address.
          </Text>
        </Stack>

        {/* End Content */}

        {/* Actions */}
        <Box
          position={{
            lg: "static",
            xs: "fixed",
          }}
          paddingTop={{
            lg: "medium",
            xs: "medium",
          }}
          paddingBottom={{
            lg: "none",
            xs: "large",
          }}
          paddingX={{
            lg: "none",
            xs: "medium",
          }}
          backgroundColor="white"
          width="full"
          style={{
            left: "0",
            bottom: "0",
            zIndex: "1",
          }}
        >
          <Box
            display="flex"
            flex-wrap={{
              lg: "noWrap",
              xs: "wrap",
            }}
            justifyContent="flex-end"
            alignItems="center"
          >
            <Box marginRight="large">
              <Button
                variant="text"
                color="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpen(false);
                }}
              >
                Cancel
              </Button>
            </Box>
            <Button onClick={(e) => onCreate(e)}>Create premises</Button>
          </Box>
        </Box>
        {/* End Actions */}
      </Stack>
    </Dialog>
  );
};

export default ConfirmCreateDuplicatePremiseModal;
